import React from "react";
import styled from "styled-components";
import BackgroundImage from "../../Images/Rectangle.png";
import {
  AuctionAbsoluteImage,
  AuctionButtonWrapper,
  AuctionNftIcon,
  AuctionNftPrice,
  AuctionNftPriceIconWrapper,
  AuctionNftText,
  AuctionpriceStartsWrapper,
  AuctionpriceTextWrapper,
  AuctionProfileEmail,
  AuctionProfileImage,
  AuctionProfileText,
  AuctionProfileTextWrapper,
  AuctionProfileWrapper,
  AuctionProfileWrapperContainer,
  AuctionText,
  AuctionTextWrapper,
  AuctionWrapperContainer,
  MagicAuctionText,
  MagicAuctionWrapper,
  NftpriceStartWrapper,
  ViewCollection,
  ViewRewardsButton,
  ViewRewardsButtonWrapper,
} from "./DashboardCoinholdingstyled";
import AuctionProfile from "../../Images/AuctionProfile.png";
import AbsoluteIcon from "../../Images/AbsoluteImage.svg";
import DiamondIcon from "../../Images/DiamondIcon.png";

const Root = styled.div`
  margin: 25px 15px;
  width: 35%;
`;
const Container = styled.div`
  /* padding: 0 15px; */
  padding:0px 60px 0 0px;
`;

export const TopAuction = () => {
  return (
    <Root>
      <Container>
        <AuctionTextWrapper>
          <AuctionText>Top Auction</AuctionText>
        </AuctionTextWrapper>

        <div style={{ position: "relative" }}>
          <AuctionWrapperContainer>
            <MagicAuctionWrapper>
              <MagicAuctionText>Magic Auction</MagicAuctionText>
            </MagicAuctionWrapper>
            <AuctionProfileWrapperContainer>
              <AuctionProfileWrapper>
                <AuctionProfileImage src={AuctionProfile} />

                <AuctionProfileTextWrapper>
                  <AuctionProfileText>Debbie Reese </AuctionProfileText>
                  <AuctionProfileEmail>@Debbie111</AuctionProfileEmail>
                </AuctionProfileTextWrapper>
              </AuctionProfileWrapper>
            </AuctionProfileWrapperContainer>
            <NftpriceStartWrapper>
              <AuctionpriceTextWrapper>
                <AuctionNftText> Price per NFT</AuctionNftText>
                <AuctionNftPriceIconWrapper>
                  <AuctionNftIcon src={DiamondIcon} />
                  <AuctionNftPrice> $80 </AuctionNftPrice>
                </AuctionNftPriceIconWrapper>
              </AuctionpriceTextWrapper>

              <AuctionpriceStartsWrapper>
                <AuctionNftText> Starts in</AuctionNftText>
                <AuctionNftPriceIconWrapper>
                  <AuctionNftPrice> 02h 32m 44s </AuctionNftPrice>
                </AuctionNftPriceIconWrapper>
              </AuctionpriceStartsWrapper>
            </NftpriceStartWrapper>

            <AuctionButtonWrapper>
              <ViewRewardsButtonWrapper>
                <ViewRewardsButton> View Rewards </ViewRewardsButton>
              </ViewRewardsButtonWrapper>

              <ViewRewardsButtonWrapper>
                <ViewCollection> View Collection </ViewCollection>
              </ViewRewardsButtonWrapper>
            </AuctionButtonWrapper>
          </AuctionWrapperContainer>
          <AuctionAbsoluteImage src={AbsoluteIcon} />
        </div>
      </Container>
    </Root>
  );
};
